import { UploadsApi } from '@/api/uploads_api'

export default {
  methods: {
    /**
     * Download a file by upload ID.
     * Can be called directly: downloadFile(uploadId, fileName)
     * Or via click event with data-upload-id and data-filename attributes on the element.
     */
    async downloadFile(uploadIdOrEvent, fileName) {
      let uploadId = uploadIdOrEvent
      let name = fileName

      // Support legacy pattern: called from v-on:click with event object
      if (uploadIdOrEvent && typeof uploadIdOrEvent === 'object' && uploadIdOrEvent.target) {
        const el = uploadIdOrEvent.currentTarget || uploadIdOrEvent.target
        uploadId = el.dataset.uploadId
        name = el.dataset.filename
      }

      if (!uploadId) {
        console.warn('FileDownload: no uploadId provided')
        return
      }

      try {
        await UploadsApi.downloadFile(uploadId, name || 'download')
      } catch (e) {
        console.error('File download failed:', e)
      }
    }
  }
}
